import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ElementObserverService } from '../../shared/services/element-observer.service';
import { faTruck } from '@fortawesome/pro-solid-svg-icons';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CityscapeScrollAnimationComponent } from '../cityscape-scroll-animation/cityscape-scroll-animation.component';

@Component({
    selector: 'app-progress-background',
    templateUrl: './progress-background.component.html',
    styleUrls: ['./progress-background.component.scss'],
    animations: [
        trigger('display', [
            state('inactive', style({
                top: '-450px',
                height: 0,
                opacity: 0
            })),
            state('busy', style({
                top: 0,
                opacity: 1,
                height: '*',
            })),
            state('done', style({
                top: '-450px',
                height: 0,
                opacity: 0
            })),
            transition('inactive => busy', animate('1s')),
            transition('busy => done', animate('1s')),
            transition('done => busy', animate('1s')),
        ])
    ],
    imports: [CityscapeScrollAnimationComponent, FontAwesomeModule]
})
export class ProgressBackgroundComponent implements OnInit, AfterViewInit {

    @Input()
    progress: number;

    @Input()
    state: 'inactive' | 'busy' | 'done' = 'inactive';

    truckIcon = faTruck;

    @ViewChild('container')
    container: ElementRef;

    constructor(private elementObserver: ElementObserverService) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {

    }


}
